import { useMutation, useQuery } from '@tanstack/react-query';
import { IInvite } from '../../Interfaces/IInvites';
import { customFetcher } from '../useFetch';

export const useGetInvitesBy = (contactId: number) => {
  const {
    data: invites,
    isFetching: isLoadingInvites,
    refetch: refetchInvites,
    error: errorInvites,
  } = useQuery<IInvite[]>({
    refetchOnWindowFocus: false,
    queryKey: ['legalclientrelationship'],
    queryFn: () =>
      customFetcher({
        endpoint: `/contactinvite/contact/getinvites/${contactId}`,
      }),
  });

  return {
    invites,
    isLoadingInvites,
    errorInvites,
    refetchInvites,
  };
};

export const useAnswerInvite = () => {
  const { mutateAsync: onAnswerInvite, isPending: isPendingAnswerInvite } =
    useMutation({
      mutationFn: (input: IInvite) =>
        customFetcher({
          endpoint: `/contactinvite/answer/${input.TempToken}`,
          method: 'POST',
          body: input,
        }),
    });

  return {
    onAnswerInvite,
    isPendingAnswerInvite,
  };
};
